import React from 'react';
import { Form, Heading, OptionType, SubmitButton } from '@medely/ui-kit';
import { ContentLoader, FixedFooterLayout } from '@mp/components';
import { AccountInfoForm } from './components/AccountInfoForm';
import { useCurrentUserForAccountInfoStep, useReferralSourcesForAccountInfoStep } from './graphql';
import { accountInfoStepSchema } from './schema';
import { MedelyInformationBox } from './components/MedelyInformationBox';
import { useAccountInfoStepMutation } from './mutations';
import { AccountInfoFormValues } from './interface';

export const AccountInfo = ({ isMobileVersion = false }: { isMobileVersion?: boolean }) => {
  const { currentUser, isLoading } = useCurrentUserForAccountInfoStep();
  const { submitAccountInfo, isSubmittingAccountInfo } = useAccountInfoStepMutation();
  const { referralSources, isLoading: isReferralSourcesLoading } =
    useReferralSourcesForAccountInfoStep();
  const referralSourceOptions: OptionType[] = referralSources?.map(({ id, label }) => ({
    value: id,
    label: label as string,
  }));

  const isReferralInfoMissing = !currentUser?.professional?.referral_source_id;

  const isAgency = Boolean(currentUser?.agency_id);

  const defaultValues = {
    first_name: currentUser?.first_name,
    last_name: currentUser?.last_name,
    nickname: currentUser?.professional?.nickname,
    address_zip: currentUser?.address_zip,
    phone_number: currentUser?.phone_number,
  };

  const handleSubmit = (values: AccountInfoFormValues) => {
    submitAccountInfo(values);
  };

  return (
    <ContentLoader loading={isLoading || isReferralSourcesLoading}>
      <Form
        defaultValues={defaultValues}
        handleSubmit={handleSubmit}
        schema={accountInfoStepSchema}
      >
        <FixedFooterLayout
          footerContent={
            <SubmitButton
              testId="account-info-next-button"
              loading={isSubmittingAccountInfo}
              disabled={isSubmittingAccountInfo}
              fullWidth
            >
              Next
            </SubmitButton>
          }
          height="96%"
        >
          <Heading size="m" textAlign={isMobileVersion ? 'center' : 'left'}>
            Let&apos;s get started with your application
          </Heading>
          <AccountInfoForm
            isReferralInfoMissing={isReferralInfoMissing}
            referralSourceOptions={referralSourceOptions}
            proEmail={currentUser?.email}
            isAgency={isAgency}
            isMobile={isMobileVersion}
          />
          <MedelyInformationBox />
        </FixedFooterLayout>
      </Form>
    </ContentLoader>
  );
};
